import { createServerFn } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { z } from "zod";
import { getConversations, getThread, postMessage } from "./messages.server";

/** The signed-in user's Shields intranet inbox — one conversation per booking. */
export const listMyConversations = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .handler(async ({ context }) => getConversations(context.supabase, context.userId));

/** Full message thread for one booking (parties only, enforced by RLS). */
export const getMessageThread = createServerFn({ method: "GET" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: unknown) => z.object({ bookingId: z.string().uuid() }).parse(d))
  .handler(async ({ data, context }) =>
    getThread(context.supabase, context.userId, data.bookingId),
  );

/** Send a message within a booking conversation. Contact details are stripped. */
export const sendMessage = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: unknown) =>
    z.object({ bookingId: z.string().uuid(), body: z.string().min(1).max(1000) }).parse(d),
  )
  .handler(async ({ data, context }) =>
    postMessage(context.supabase, context.userId, data.bookingId, data.body),
  );
